import { Typography } from "@mui/material";
import React from "react";

import { amazonColors } from "../../../config/amazonTheme";

interface ProductBreadcrumbsProps {
  categories: string[];
}

const ProductBreadcrumbs: React.FC<ProductBreadcrumbsProps> = ({
  categories,
}) => {
  if (categories.length === 0) return null;

  const categoryPath = categories.join(" > ");

  return (
    <Typography
      sx={{
        mb: 3,
        color: amazonColors.text.secondary,
        fontSize: "0.875rem",
      }}
    >
      {categoryPath}
    </Typography>
  );
};

export default ProductBreadcrumbs;
